// import Swal from 'sweetalert2';
import '../js/uploader';
import '../js/select2';
// import Validation from '../js/validation';
import '../partials/account/currency/calendar';
